import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromAutenticacionActions from './autenticacion.actions';
import { AutenticacionState } from './autenticacion.model';
import { Observable } from 'rxjs';
import * as fromSelectorAutenticacion from './autenticacion.selectors';
import { ValidarUsuarioDto } from '../dto/validarUsuarioDto';
import { SessionDto } from '../../../core/data/SessionDto';
import { OpcionesPerfilRolDto } from 'src/app/core/data/OpcionesPerfilRolDto';

@Injectable({
  providedIn: 'root'
})
export class AutenticacionStoreService {

  constructor(private store: Store<AutenticacionState>) {
  }

  // COM Session****
  public adicionarSession(_newSession: SessionDto): void {
    this.store.dispatch(
      fromAutenticacionActions.addSession({
        _newSession: { ..._newSession }
      }));
  }

  public removeSession(): void {
    this.store.dispatch(
      fromAutenticacionActions.removeSession());
  }

  // COM Temporal session
  public adicionarTemporalSession(_newTemporalSession: ValidarUsuarioDto): void {
    this.store.dispatch(
      fromAutenticacionActions.addTemporalSession({
        _newTemporalSession: { ..._newTemporalSession }
      }));
  }

  public removeTemporalSession(): void {
    this.store.dispatch(
      fromAutenticacionActions.removeTemporalSession());
  }

  // COM Perfil****
  public adicionarPerfil(newPerfil: OpcionesPerfilRolDto): void {
    this.store.dispatch(
      fromAutenticacionActions.addPerfil({
        newPerfil: { ...newPerfil }
      }));
  }

  public removePerfil(): void {
    this.store.dispatch(
      fromAutenticacionActions.removePerfil());
  }

  // COM Selectores ********************
  public obtenerSession$(): Observable<SessionDto> {
    return this.store.select(fromSelectorAutenticacion.selectSession);
  }

  public obtenerTemporalSession$(): Observable<ValidarUsuarioDto> {
    return this.store.select(fromSelectorAutenticacion.selectTemporalSession);
  }

  public obtenerPerfiles$(): Observable<OpcionesPerfilRolDto> {
    return this.store.select(fromSelectorAutenticacion.selectPerfil);
  }
}
